import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {Partenaires} from "./Home/Partenaires";

import maison from './../assets/images/maison.svg';
import ActeurService from "../service/ActeurSevice";
import {urlDirectus} from "../config/Globals";

export const PartenairePage = () => {
    const[acteurs, setActeurs] = useState([]);
    const[loadingActeurs, setLoadingActeurs] = useState(1);
    const fetchActeurs = async() => {
        try{
            const data = await ActeurService.findAll();
            setActeurs(data);
            setLoadingActeurs(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchActeurs();
    }, []);

    return (
        <>
            <Helmet>
                <title>Les acteurs de la lutte</title>
                <meta name="description" content="Les acteurs de la lutte contre la Flavescence dorée définissent le plan de lutte obligatoire qui repose sur les 4 piliers complémentaires." />
            </Helmet>
            <main className="type partenaires">
                <section className="bg-gris pb-5">
                    <div className="container px-4 pb-5 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href="/" className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            Partenaires
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="display-5 fw-sb mb-3">Les acteurs de la lutte</h1>
                                <div className="fw-b fs-6">
                                    <p>Les acteurs de la lutte contre la Flavescence dorée définissent le plan de lutte bligatoire qui repose sur les 4 piliers complémentaires.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4 mt-4 mt-lg-0 py-lg-5 bg-white justify-content-center">
                            {acteurs.map((acteur, index) => {
                                // Détermine si c'est le premier ou le dernier élément pour appliquer col-lg-10
                                const isLarge = index === 0 || index === acteurs.length - 1;
                                const colClass = isLarge ? "col-12 col-lg-10" : "col-12 col-lg-5";

                                // Ajustement Bootstrap pour aligner verticalement le premier élément (comme dans votre HTML de base)
                                const flexAlignment = index === 0
                                    ? "align-items-start align-items-sm-center"
                                    : "align-items-start";

                                return (
                                    <div key={acteur.id} className={colClass}>
                                        <div className={`bg-violet text-white p-4 d-flex flex-column flex-sm-row ${flexAlignment} gap-4 h-100`}>
                                            <div
                                                className="bg-white rounded-circle d-flex align-items-center overflow-hidden justify-content-center flex-shrink-0"
                                                style={{ width: '100px', height: '100px' }}
                                            >
                                                <img
                                                    src={`${urlDirectus}assets/${acteur.logo}`}
                                                    alt={acteur.titre}
                                                    className="p-3 w-100 h-100 object-fit-contain img-fluid"
                                                />
                                            </div>
                                            <div>
                                                <div className="d-flex flex-column flex-wrap align-items-start gap-3 mb-2">
                                                    <h2 className="h5 fw-b mb-0">{acteur.titre}</h2>
                                                    <span className="badge-outline-custom">{acteur.action}</span>
                                                </div>
                                                <p className="mb-0 fs-6 opacity-90">{acteur.description}</p>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    )
}